let scrollRevealObserver: IntersectionObserver | null = null

export function useScrollReveal() {
  scrollRevealObserver?.disconnect()

  scrollRevealObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible')
        scrollRevealObserver?.unobserve(entry.target)
      }
    })
  }, { threshold: 0.12 })

  document.querySelectorAll('.reveal:not(.visible)').forEach((el) => {
    scrollRevealObserver?.observe(el)
  })
}

export function useEmailSuccessToast() {
  if (!window.location.search.includes('emailsuccess=1')) return

  const { messages: m } = useI18n()
  const toast = document.createElement('div')
  toast.innerText = m.value.toast.emailSuccess
  toast.style.cssText = 'position:fixed;top:30px;left:50%;transform:translateX(-50%);background:#4CAF50;color:#fff;padding:14px 24px;border-radius:8px;z-index:99999;white-space:nowrap;box-shadow:0 4px 20px rgba(0,0,0,0.3);'
  document.body.appendChild(toast)
  setTimeout(() => {
    toast.remove()
    const params = new URLSearchParams(window.location.search)
    params.delete('emailsuccess')
    const search = params.toString()
    history.replaceState(null, '', `${location.pathname}${search ? `?${search}` : ''}${location.hash}`)
  }, 5200)
}